import WahaSessionsIndex from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/waha-sessions'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'waha_sessions',
          component: WahaSessionsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
